import { SaleStatus, usePool, useSaleTimeline } from '@trustpad/launchpad';
import { fNum } from '@trustpad/launchpad/dist/shared/utils';

import * as React from 'react';

import { ListItem } from '~/features/pools/components/PoolSecondaryBlock/InfoListItem';
import { Title } from '~/features/pools/components/PoolSecondaryBlock/UI';
import { NftPoolConfig } from '~/features/pools/types';
import { getHardCap } from '~/features/pools/utils';
import { TMain } from '~common/UI';
import { useSaleBaseAllocation } from '~features/pools';
import { capitalize } from '~utils';

import {
  SaleRegistrationStartEndItem,
  SaleStartEndItem,
} from './SaleDatesItems';

export function NFTSaleSection() {
  const {
    pool: { sale, access, fundToken },
  } = usePool<NftPoolConfig>();

  const { start, end, registerStart, registerEnd, fcfsStart } =
    useSaleTimeline();
  const { baseCurrencyAllocation } = useSaleBaseAllocation();

  return (
    <div className="space-y-3">
      <Title>Pool Details</Title>

      <div className="flex flex-col md:flex-row flex-wrap">
        <div className="md:w-1/2">
          <ListItem label="Access Type">
            {false
              ? 'BLACK'
              : sale.isTiered
              ? 'Levels'
              : access === 'levels_fcfs'
              ? 'Levels FCFS'
              : capitalize(access)}
          </ListItem>
        </div>
        <div className="md:w-1/2">
          <ListItem label="Hard Cap">{getHardCap(sale, fundToken)}</ListItem>
        </div>
      </div>

      <ul>
        <SaleStartEndItem start={start} end={end} />

        {sale.status < SaleStatus.open && (
          <SaleRegistrationStartEndItem
            start={registerStart}
            end={registerEnd}
          />
        )}

        {fcfsStart && (
          <ListItem label="FCFS Opens">
            {fcfsStart.format('D MMM, HH:mm a')} UTC ({sale.fcfsDuration * 60}m
            before the end)
          </ListItem>
        )}

        {/*{sale.status >= SaleStatus.register && (*/}
        {/*  <ListItem label="Base Allocation">*/}
        {/*    <TMain>1x</TMain> ={' '}*/}
        {/*    <TMain>*/}
        {/*      {fundToken.symbol === 'BUSD'*/}
        {/*        ? `$${fNum(baseCurrencyAllocation, 2)}`*/}
        {/*        : `${fNum(baseCurrencyAllocation, 2)} ${fundToken.symbol}`}*/}
        {/*    </TMain>*/}
        {/*    {sale.baseAllocation.eqn(0) && ' (approx)'}*/}
        {/*  </ListItem>*/}
        {/*)}*/}
      </ul>
    </div>
  );
}
